import React, { useState, useEffect } from "react";
import "./Header.scss";
import Logo from "../../assets/images/new_code_smith_logo_white.png";
import { Link } from "react-router-dom";
import MobileHamburgerMenu from "./MobileHamburgerMenu";

function Header() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 991);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="nav-bar">
      <Link to={"/"}>
        <div className="nav-logo">
          <img className="name-logo" src={Logo} alt="" height="65px" />
          <h1>new code smith</h1>
        </div>
      </Link>

      {isMobile ? (
        <MobileHamburgerMenu />
      ) : (
        <div className="nav-bar-buttons">
          <Link to={"/about"}>about</Link>
          <Link to={"/development"}>development</Link>
          <Link to={"/music"}>music</Link>
          <Link to={"/contact"}>contact</Link>
        </div>
      )}
    </div>
  );
}

export default Header;
